import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import {getWebComponentInstance} from "fg-frontend/src/webComponents/decorate";
import $ from "jquery";
import {execute} from "fg-frontend/src/partialUpdate/partialUpdate";


const fragments = {
	PRODUCT_NOMINAL_VALUE: '[data-fragment="OrderNominal.productNominalValue"]',
	PRODUCT_NOMINAL_COUNT: '[data-fragment="OrderNominal.productNominalCount"]',
	PRODUCT_NOMINAL_CARD: '[data-fragment="OrderNominal.productNominalCard"]',
	PRODUCT_NOMINAL_CARD_INPUT: '[data-fragment="OrderNominal.productNominalCard"] input',
	PRODUCT_NOMINAL_BRANCH_ROW: 'tbody tr[data-total-sum]',
	PRODUCT_NOMINAL_TOTAL_SUM: '[data-fragment="OrderNominal.productNominalTotalSum"]',
	ANONYMOUS_AMOUNT: '[data-fragment="OrderNominal.anonymousAmount"]',
	ANONYMOUS_AMOUNT_NOMINAL: '[data-fragment="OrderNominal.anonymousAmountNominal"]',
	COUNT_PER_PACKAGE: '[data-fragment="OrderNominal.countPerPackage"]',
	ALLOW_EDIT: '[data-fragment="OrderNominal.allowEdit"]',
};

class OrderNominal extends WebComponent {
	constructor(props) {
		super(props);
		const {
			currentActiveRowNominalItems = 1,
		} = props;
		this.state = {
			currentActiveRowNominalItems,
		}
	}

	didMount() {
		const {
			commitClass,
		} = this.props;

		this.commitClass = commitClass;

		const universalPreloaderComponentElement = document.getElementById('universalPreloader');
		this.universalPreloaderComponent = getWebComponentInstance(universalPreloaderComponentElement);

		this.productNominalTotalSumElement = document.querySelector(fragments.PRODUCT_NOMINAL_TOTAL_SUM);
		this.productNominalBranchRowElement = document.querySelectorAll(fragments.PRODUCT_NOMINAL_BRANCH_ROW);
		this.productNominalCardElement = document.querySelectorAll(fragments.PRODUCT_NOMINAL_CARD);
		this.initOrderNominalItemCardForFilters();
		this.allowEditElement = this.element.querySelector(fragments.ALLOW_EDIT);
		if(this.allowEditElement){
			this.on('click', fragments.ALLOW_EDIT, this.handleClickOnAllowEdit);
		} else {
			this.initListeners();
		}

		this.initFirstRecountNominal();
	}

	initListeners = () => {
		this.initListenerForNominalSelect(fragments.PRODUCT_NOMINAL_VALUE, this.handleChange);
		this.initListenerForNominalSelect(fragments.ANONYMOUS_AMOUNT_NOMINAL, this.handleChangeAnonymousAmount);
		this.on('change', fragments.PRODUCT_NOMINAL_COUNT, this.debounce(this.handleChange, 500));
		this.on('keyup', fragments.PRODUCT_NOMINAL_COUNT, this.debounce(this.handleChange, 500));
		/* osetreni keydown aby se nesubmitoval form v textinputech */
		this.on('keydown', fragments.PRODUCT_NOMINAL_COUNT, this.clickOnKey);
		this.on('keydown', fragments.ANONYMOUS_AMOUNT, this.clickOnKey);
		this.on('keydown', fragments.COUNT_PER_PACKAGE, this.clickOnKey);
		this.on('change', fragments.ANONYMOUS_AMOUNT, this.handleChangeAnonymousAmount);
		this.on('change', fragments.COUNT_PER_PACKAGE, this.handleChangeCountPerPackage);
	}

	initListenerForNominalSelect = (selector, handleFunction) => {
		$(selector).on('change', handleFunction);
		$(selector).on('select2:selecting', (e) => {
			e.target.dataset.nominalIdOld = e.target.querySelector('option:checked').getAttribute('data-nominal-id');
		});
	}

	handleClickOnAllowEdit = (e) => {
		e.preventDefault();
		let disabledElement = document.querySelectorAll('.order-nominal__item--disabled');
		for(let i = 0; i < disabledElement.length; i++) {
			disabledElement[i].classList.remove('order-nominal__item--disabled');
		}
		let activeRow = document.querySelector('.cursor-pointer.active').nextElementSibling;
		let disabledElementInput = document.querySelectorAll('input[disabled]');
		let disabledElementSelect = activeRow.querySelectorAll('select[disabled]');
		for(let j = 0; j < disabledElementInput.length; j++) {
			disabledElementInput[j].removeAttribute('disabled');
		}
		for(let j = 0; j < disabledElementSelect.length; j++) {
			disabledElementSelect[j].removeAttribute('disabled');
		}
		this.initListeners();
		e.currentTarget.innerHTML = '';
	}

	/* Přepočítej pole při inicializace */
	initFirstRecountNominal = () => {
		let dataFilterBranch = this.element.querySelector('#nominalListPerBranch');
		let dataProductItem = this.element.querySelectorAll('thead th[data-product-id]');
		let i;
		for(i = 0; i < dataProductItem.length; i++) {
			this.recountProductNominal(dataProductItem[i].getAttribute('data-product-id'), dataFilterBranch.getAttribute('data-filter-branch-id'));
		}
	};

	addNominalRows = (productId, elId) => {
		this.setState({
			currentActiveRowNominalItems: elId,
		})
		let activeRow = document.querySelector('.cursor-pointer.active').nextElementSibling;
		let productNominalCell = activeRow.querySelectorAll('tbody.order-nominal__tbody td[data-product-id="'+productId+'"]');

		let productNominalAnonymousAmountEl = activeRow.querySelectorAll(fragments.ANONYMOUS_AMOUNT);
		let productNominalAnonymousAmountNominalEl = activeRow.querySelectorAll(fragments.ANONYMOUS_AMOUNT_NOMINAL);

		// Proiteruje bunky s produktem id
		for(let i = 0; i < productNominalCell.length; i++ ){
			let elSelect = productNominalCell[i].querySelector('select');
			if(elSelect) {
				this.clonedNominalElementSelect(elSelect, elId, this.handleChange);
			}
			let elInput = productNominalCell[i].querySelector('input[type="text"]');
			if(elInput) {
				this.clonedNominalElementInput(elInput, elId);
			}
		}

		// Anonymní množství
		if((productNominalAnonymousAmountEl.length > 0 && productNominalAnonymousAmountNominalEl.length > 0)) {
			if(productNominalAnonymousAmountEl[0].getAttribute('data-product-id') === productId){
				this.clonedNominalElementInput(productNominalAnonymousAmountEl[0], elId);
				this.clonedNominalElementSelect(productNominalAnonymousAmountNominalEl[0], elId, this.handleChangeAnonymousAmount);
			}
		}
		//	Počet stranvych listok per obalka
		// let productNominalCountPerPackageEl = activeRow.querySelectorAll(fragments.COUNT_PER_PACKAGE);
		// if(productNominalCountPerPackageEl.length === 1) {
		// 	if(productNominalCountPerPackageEl[0].getAttribute('data-product-id') === productId){
		// 		this.clonedNominalElementInput(productNominalCountPerPackageEl[0], elId);
		// 	}
		// }
	}

	clonedNominalElementSelect = (el, elId, handleFunction) => {
		let curElement = el;
		var isIE = /MSIE|Trident/.test(window.navigator.userAgent);
		if(el.dataset.is === 'SelectDesign') {
			if(!isIE) {
				$(curElement).select2('destroy');
			}
		}
		let divEl = document.createElement('div');
		let clonedEl = curElement.cloneNode(true);
		clonedEl.setAttribute('data-nominal-id-old', '');
		clonedEl.setAttribute('id', curElement.id + '-' + elId);
		divEl.appendChild(clonedEl);
		curElement.parentElement.parentNode.appendChild(divEl);
		let selectorNewElement = '#' + curElement.id + '-' + elId;
		if(el.dataset.is === 'SelectDesign') {
			if(!isIE) {
				$(curElement).select2({
					minimumResultsForSearch: Infinity
				});
				$(selectorNewElement).select2({
					minimumResultsForSearch: Infinity
				});
			}
		}
		this.initListenerForNominalSelect(selectorNewElement,handleFunction);
	}

	clonedNominalElementInput = (el, elId) => {
		let curElement = el.parentElement;
		let clonedEl = curElement.cloneNode(true);
		let clonedElInput = clonedEl.querySelector('input');
		clonedElInput.value = 0;
		clonedElInput.setAttribute('id', clonedElInput.id + '-' + elId);
		curElement.parentNode.appendChild(clonedEl);
	}

	removeNominalRows = (productId, elId) => {
		this.setState({
			currentActiveRowNominalItems: elId,
		})
		let activeRow = document.querySelector('.cursor-pointer.active').nextElementSibling;
		let productNominalCountEl = activeRow.querySelectorAll("input[id$='-"+ elId+"'][data-product-id='"+productId+"']");
		this.commitChangeAnonymousAmount(0);
		// Počet
		for(let i = 0; i < productNominalCountEl.length; i++) {
			this.addCommitClass(productNominalCountEl[i]);
		}
		this.commitChanges(0, productId);
	}

	removeNominalRowsAfterCommit = (productId) => {
		if(productId > 0){
			let activeRow = document.querySelector('.cursor-pointer.active').nextElementSibling;
			let productNominalCell = activeRow.querySelectorAll('tbody td[data-product-id="'+productId+'"]');
			if(productNominalCell.length > 0) {
				let branchId = productNominalCell[0].querySelector('select').getAttribute('data-branch-id');
				for(let i = 0; i < productNominalCell.length; i++) {
					let productNominalValueEl = productNominalCell[i].querySelectorAll('select');
					if(productNominalValueEl.length > 0) {
						productNominalValueEl[productNominalValueEl.length-1].parentElement.remove();
					}
					let productNominalCountEl = productNominalCell[i].querySelectorAll('input[type="text"]');
					if(productNominalCountEl.length > 0) {
						productNominalCountEl[productNominalCountEl.length-1].parentElement.remove();
					}
				}
				this.recountProductNominal(productId, branchId);
			}
		}
	}

	clickOnKey = (e) => {
		let key = e.which || e.keyCode;
		switch(key) {
			case 13:
				e.preventDefault();
				break;
			default:
		}
	};

	handleChange = (e, isTrusted) => {
		let productId = e.target.dataset.productId;
		let branchId = e.target.dataset.branchId;
		this.addCommitClass(e.target);
		if(e.target.tagName === 'INPUT') {
		  	this.initOrderNominalItemCard(e.target);
		}
		 if(typeof(isTrusted) == "undefined" ){
			this.recountProductNominal(productId, branchId);
		 }
	};

	handleChangeAnonymousAmount = (e) => {
		let productId = e.target.dataset.productId;
		let branchId = e.target.dataset.branchId;
		this.commitChangeAnonymousAmount(e);
		this.recountProductNominal(productId, branchId);
	};

	handleChangeCountPerPackage = (e) => {
		this.commitChangeCountPerPackage(e);
	};

	initOrderNominalItemCard = (e) => {
		let orderNominalItemCard = e.parentElement.parentElement.parentElement.querySelector('.order-nominal__item--card');
		if(orderNominalItemCard) {
			if(!orderNominalItemCard.classList.contains('order-nominal__item--card-has-managed')) {
				let orderNominalItemCardInput = orderNominalItemCard.querySelector('input');
				if(e.value > 0) {
					orderNominalItemCard.classList.remove('order-nominal__item--hide');
					orderNominalItemCardInput.checked = true;
				} else {
					orderNominalItemCard.classList.add('order-nominal__item--hide');
					orderNominalItemCardInput.checked = false;
				}
			}
		}
	};

	initOrderNominalItemCardForFilters = () => {
		this.productNominalCardElement.forEach((el) => {
			if(el.classList.contains("order-nominal__item--card-has-managed")) {
				el.closest('tr').setAttribute("active-card", "true");
			}
		});
		let productSetCard = this.element.querySelector("#productSetCard");
		let nominalTableRows = this.element.querySelectorAll("#nominalListPerBranch table tbody tr");
		if(productSetCard) {
			$(productSetCard).on('select2:select', (e) => {
				let displayAll = e.target.value === 'all';
				let displayActive = e.target.value === 'cardActive';
				let displayCardOrder = e.target.value === 'cardOrder';
				nominalTableRows.forEach((el) => {
					if(displayCardOrder) {
						if(!el.hasAttribute("active-card")) {
							let checkCard = el.querySelector(".order-nominal__item--card input[type='checkbox']");
							if(checkCard && checkCard.checked) {
								el.style.display = "table";
							} else {
								el.style.display = "none";
							}
						} else {
							el.style.display = "none";
						}
					} else {
						el.style.display = displayAll || (displayActive === el.hasAttribute("active-card")) ? "table" : "none";
					}
				});
			});
		}
	}

	debounce = (func, delay) => {
		let debounceTimer;
		return function() {
			const context = this;
			const args = arguments;
			clearTimeout(debounceTimer);
			debounceTimer = setTimeout(() => func.apply(context, args), delay)
		}
	};

	/* Funkce proiteruje vsechny selecty (hodnoty) v tabulce a dle id urcuje jaká hodnota se má danému elementu přiradit */
	changeProductNominalValueColumn = (values, productId, branchId)  => {
		let i;
		let productNominalValue = this.element.querySelectorAll('tbody tr:not([style*="display: none"])[data-branch-id="'+branchId+'"] select[data-product-id="'+productId+'"]');
		for(i = 0; i < productNominalValue.length; i++) {
			let elementId = productNominalValue[i].id.slice(-1);
			let elementValue = values[0];
			if(elementId === elementId) {
				elementValue = values[elementId];
			}
			$(productNominalValue[i]).trigger('select2:selecting');
			$(productNominalValue[i]).find(' option[data-nominal-id="'+ elementValue +'"]').prop("selected",true).trigger('change',false);
		}
		this.recountProductNominal(productId, branchId);
	};
	/* Funkce proiteruje vsechny inputy (počty) v tabulce a dle id urcuje jaká hodnota se má danému elementu přiradit */
	changeProductNominalCountColumn = (values, productId, branchId) => {
		let i;
		let productNominalCount = this.element.querySelectorAll('tbody tr:not([style*="display: none"])[data-branch-id="'+branchId+'"] input[data-product-id="'+productId+'"]');
		for(i = 0; i < productNominalCount.length;i++) {
			let elementId = productNominalCount[i].id.slice(-1);
			let elementValue = values[0];
			if(elementId === elementId) {
				elementValue = values[elementId];
			}
			if(elementValue !== ''){
				productNominalCount[i].value = elementValue;
			}
			this.addCommitClass(productNominalCount[i]);
			this.initOrderNominalItemCard(productNominalCount[i]);
		}
		this.recountProductNominal(productId, branchId);
	};
	/* Funkce proiteruje vsechny řádky v tabulce a dle hodnot spočítá mezivýsledky per OM */
	recountProductNominal = (productId, branchId) => {
		let i,j,k;
		let totalSum = 0, totalSumCount = 0;
		let productNominalRow = this.element.querySelectorAll('tbody tr[data-branch-id="'+branchId+'"]');
		for(i = 0; i < productNominalRow.length;i++) {
			let productNominalRowValues = productNominalRow[i].querySelectorAll('select[data-fragment="OrderNominal.productNominalValue"][data-product-id="'+productId+'"]'); // Hodnota
			let productNominalRowCounts = productNominalRow[i].querySelectorAll('input[data-fragment="OrderNominal.productNominalCount"][data-product-id="'+productId+'"]');  // Počet
			for(k = 0; k < productNominalRowValues.length; k++) {
				totalSumCount = totalSumCount + parseInt(productNominalRowCounts[k].value);
				totalSum = totalSum + (parseFloat(productNominalRowValues[k].value.replace(',','.')) * parseInt(productNominalRowCounts[k].value));
			}
		}

		let totalSumCountElement  = this.element.querySelector('.order-nominal__total-sum--count[data-product-id="'+productId+'"]');
		if(totalSumCountElement) {
			totalSumCountElement.innerHTML = totalSumCount.toString();
		}
		let totalSumValueElement = this.element.querySelector('.order-nominal__total-sum--value[data-product-id="'+productId+'"]');
		if(totalSumValueElement) {
			totalSumValueElement.innerHTML = totalSum.toFixed(2).toString() + ' €';
		}

		let dataTotalSum = 0;
		let dataFilterRowId = document.querySelector('tbody tr[data-filter-row-id="'+branchId+'"]');
		let orderNominalTotalSumValue = this.element.querySelectorAll('.order-nominal__total-sum--value');
		for(i = 0; i <orderNominalTotalSumValue.length; i++) {
		  dataTotalSum = dataTotalSum + parseFloat(orderNominalTotalSumValue[i].innerText);
		}
		/* Přičíst anonymni mnozstvi u papiroveho produktu*/
		let anonymousAmountSum = 0;
		let anonymousAmount;
		let anonymousAmountNominal;
		if(dataFilterRowId.nextElementSibling) {
			anonymousAmount = dataFilterRowId.nextElementSibling.querySelector(fragments.ANONYMOUS_AMOUNT);
			anonymousAmountNominal = dataFilterRowId.nextElementSibling.querySelector(fragments.ANONYMOUS_AMOUNT_NOMINAL);
		}
		if(anonymousAmount && anonymousAmount.value > 0) {
			if(anonymousAmountNominal){
				anonymousAmountSum = (parseFloat(anonymousAmountNominal.value.replace(',','.')) * parseInt(anonymousAmount.value));
			}
		}
		dataTotalSum = dataTotalSum + anonymousAmountSum;

		dataFilterRowId.setAttribute('data-total-sum', dataTotalSum.toString());

		// this.recountProductNominalTotalSum();
		/*pokud se změněj hodnoty udělej autosubmit formuláře*/
		this.commitChanges();
	};
	/* Funkce proiteruje vsechny OM řádky a získa atribut data-total-sum a sečte hodnoty */
	recountProductNominalTotalSum = () => {
		let i;
		let totalSum = 0;
		for(i = 0; i < this.productNominalBranchRowElement.length; i++) {
			let dataTotalSumRow = this.productNominalBranchRowElement[i].getAttribute('data-total-sum');
			totalSum = totalSum + parseFloat(dataTotalSumRow);
		}
		this.productNominalTotalSumElement.innerHTML = totalSum.toFixed(2).toString();
	};
	/* Řazení tabulky per OM dle jména a příjmení či osobního čísla */
	filterRows = (filterFullName, filterEmployeeNumber, branchId) => {
		let i;
		let productNominalRows = this.element.querySelectorAll('tbody tr[data-branch-id="'+branchId+'"]');
		for(i = 0; i < productNominalRows.length;i++) {
			if(productNominalRows[i].getAttribute('data-full-name').includes(filterFullName.toLowerCase())) {
				productNominalRows[i].style.display = 'table';
			} else {
				productNominalRows[i].style.display = 'none';
			}
		}
		productNominalRows = this.element.querySelectorAll('tbody tr:not([style*="display: none"])[data-branch-id="'+branchId+'"]');
		for(i = 0; i < productNominalRows.length;i++) {
			if (productNominalRows[i].getAttribute('data-employee-number').includes(filterEmployeeNumber.toLowerCase())) {
				productNominalRows[i].style.display = 'table';
			} else {
				productNominalRows[i].style.display = 'none';
			}
		}
	};
	/* Přidá classu toCommit, používá se pro iteraci pri commitování zmen, po uspesnem odeslani na server je commit classa ostranena*/
	addCommitClass = (e) => {
		// pridej classu k rádku
		let parentTd = e;
		do {
			parentTd = parentTd.parentElement;
		} while(!(parentTd.nodeName === 'TD'));
		parentTd.classList.add(this.commitClass);
	};
	/* Získání csrf hodnotu z formuláře */
	getCsrfToken = () => {
		return document.querySelector('form[id^=orderRecord] input[name=csrf]').value;
	};
	/* Získání formId hodnotu z formulare */
	getFormId = () => {
		return document.querySelector('form[id^=orderRecord] input[name=formId]').value;
	};
	/* Odešle data na server */
	commitChanges = (defCount, productId) => {
		let toCommitElements = this.element.querySelectorAll('.order-nominal tbody td.toCommit');
		let i, j, dataJSON = [];
		let _self = this;
		if(toCommitElements.length > 0) {
			for(i = 0; i <toCommitElements.length; i++){
				let dataTableCell = toCommitElements[i];
				let dataTableRow = dataTableCell.parentElement;
				let inputCardElement = dataTableCell.querySelector('input[type="checkbox"]'); // Karta
				let inputCardElementValue = 0;
				if(inputCardElement) {
					if(inputCardElement.checked) {
						inputCardElementValue = 1;
					} else {
						inputCardElementValue = 0;
					}
				}
				let inputElements = dataTableCell.querySelectorAll('input[type="text"]'); // Počet
				let selectElements = dataTableCell.querySelectorAll('select'); // Hodnota
				for(j = 0; j < inputElements.length; j++) {
					let dataNominalIdOld = selectElements[j].getAttribute('data-nominal-id-old');
					if(dataNominalIdOld === "") {
						dataNominalIdOld = null;
					}
					dataJSON.push({
						card: inputCardElementValue,
						personId: dataTableRow.getAttribute('data-person-id'),
						productId: inputElements[j].getAttribute('data-product-id'),
						branchId: dataTableRow.getAttribute('data-branch-id'),
						oldValue: dataNominalIdOld,
						value: selectElements[j].options[selectElements[j].selectedIndex].getAttribute('data-nominal-id'),
						count: (defCount === 0 && j > 0) ? "0" : inputElements[j].value
					});
				}
			}
			this.universalPreloaderComponent.handleOn(10);
			let commitUrl = '/order/step4?formId=' + this.getFormId() + '&csrf=' + this.getCsrfToken() + '&eventName.storeData:orderRecord=';
			let xmlHttpReq = new XMLHttpRequest();
			xmlHttpReq.open('POST', commitUrl, true);
			xmlHttpReq.setRequestHeader("Content-Type", "application/json");
			xmlHttpReq.onreadystatechange = function () {
				if (xmlHttpReq.readyState === 4) {
					if (xmlHttpReq.status === 200) {
						let response = JSON.parse(xmlHttpReq.responseText);
						console.log("onreadystatechange to server - " + response.ok);
						if(response.ok){
							for(i = 0; i <toCommitElements.length; i++){
								toCommitElements[i].classList.remove(_self.commitClass);
								let selectEl = toCommitElements[i].querySelector('select');
								if(selectEl){
									selectEl.setAttribute('data-nominal-id-old', '');
								}
							}
							_self.removeNominalRowsAfterCommit(productId);
							if(typeof(response.data.price) != 'undefined') {
								_self.productNominalTotalSumElement.innerHTML = response.data.price.toFixed(2).toString();
							} else {
								execute({
									url: _self.href,
									target: 'productNominalTotalSum',
								});
							}
						}
					}

				}
				_self.universalPreloaderComponent.handleOff(10);
			};
			xmlHttpReq.send(JSON.stringify(dataJSON));
		}

	};

	commitChangeAnonymousAmount = (defCount) => {
		const {
			currentActiveRowNominalItems,
		} = this.state;
		let dataJSON = [];
		let i;
		let _self = this;
		let toCommitElements = this.element.querySelector('.anonymous-amount');
		if(toCommitElements) {
			let tableParentElement = toCommitElements.parentElement.parentElement;
			let inputElementValues = toCommitElements.querySelectorAll('input');
			let inputElementNominals = toCommitElements.querySelectorAll('select');
			let productId;
			for(let i = 0; i <inputElementValues.length; i++) {
				productId = tableParentElement.getAttribute('data-product-id');
				let dataNominalIdOld = inputElementNominals[i].getAttribute('data-nominal-id-old');
				if(dataNominalIdOld === "") {
					dataNominalIdOld = null;
				}
				dataJSON.push({
					card: null,
					personId: null,
					productId: productId,
					branchId: tableParentElement.getAttribute('data-branch-id'),
					oldValue: dataNominalIdOld,
					value: inputElementNominals[i].options[inputElementNominals[i].selectedIndex].getAttribute('data-nominal-id'),
					count: (defCount === 0 && i > 0) ? "0" : inputElementValues[i].value
				});
			}
			this.universalPreloaderComponent.handleOn(10);
			let commitUrl = '/order/step4?formId=' + this.getFormId() + '&csrf=' + this.getCsrfToken() + '&eventName.storeData:orderRecord=';
			let xmlHttpReq = new XMLHttpRequest();
			xmlHttpReq.open('POST', commitUrl, true);
			xmlHttpReq.setRequestHeader("Content-Type", "application/json");
			xmlHttpReq.onreadystatechange = function () {
				if (xmlHttpReq.readyState === 4) {
					if (xmlHttpReq.status === 200) {
						let response = JSON.parse(xmlHttpReq.responseText);
						console.log("onreadystatechange to server - " + response.ok);
						if(response.ok){
							for(i = 0; i <inputElementNominals.length; i++){
								if(inputElementNominals[i]){
									inputElementNominals[i].setAttribute('data-nominal-id-old', '');
								}
							}
							if(typeof(response.data.price) != 'undefined') {
								_self.productNominalTotalSumElement.innerHTML = response.data.price.toFixed(2).toString();
							} else {
								execute({
									url: _self.href,
									target: 'productNominalTotalSum',
								});
							}
						}
					}

				}
				_self.universalPreloaderComponent.handleOff(10);
			};
			xmlHttpReq.send(JSON.stringify(dataJSON));
		}

	};

	commitChangeCountPerPackage = (defCount) => {
		let dataJSON = [];
		let _self = this;
		let toCommitElements = this.element.querySelector('.count-per-package');
		if(toCommitElements) {
			let tableParentElement = toCommitElements.parentElement.parentElement;
			let inputElementValues = toCommitElements.querySelectorAll('input');
			for(let i = 0; i <inputElementValues.length; i++) {
				dataJSON.push({
					branchId: tableParentElement.getAttribute('data-branch-id'),
					itemsPerEnvelope: (defCount === 0 && i > 0) ? "0" : inputElementValues[i].value
				});
			}
			this.universalPreloaderComponent.handleOn(10);
			let commitUrl = '/order/step4?formId=' + this.getFormId() + '&csrf=' + this.getCsrfToken() + '&eventName.storeDataPerEnvelope:orderRecord=';
			let xmlHttpReq = new XMLHttpRequest();
			xmlHttpReq.open('POST', commitUrl, true);
			xmlHttpReq.setRequestHeader("Content-Type", "application/json");
			xmlHttpReq.onreadystatechange = function () {
				if (xmlHttpReq.readyState === 4) {
					if (xmlHttpReq.status === 200) {
						let response = JSON.parse(xmlHttpReq.responseText);
						console.log("onreadystatechange to server - " + response.ok);
					}
				}
				_self.universalPreloaderComponent.handleOff(10);
			};
			xmlHttpReq.send(JSON.stringify(dataJSON));
		}

	};
}

OrderNominal.defaultProps = {
	commitClass: 'toCommit',
};

export default OrderNominal;



// WEBPACK FOOTER //
// ./config/module-publish/resources/js/components/Orders/OrderNominal.js